._container_1ujlx_1 {
  z-index: 2000;
  position: fixed;
  right: 0;
  top: 92px;
  height: calc(100% - 92px); }
